import { render, staticRenderFns } from "./TaskContainer.vue?vue&type=template&id=39d0986c&scoped=true"
import script from "./TaskContainer.vue?vue&type=script&lang=js"
export * from "./TaskContainer.vue?vue&type=script&lang=js"
import style0 from "./TaskContainer.vue?vue&type=style&index=0&id=39d0986c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d0986c",
  null
  
)

export default component.exports